import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { DarkModeProvider, useDarkMode } from './context/DarkModeContext';
import HomePage from './pages/HomePage';
import TextComparePage from './pages/TextComparePage';
import TextCheckerPage from './pages/TextCheckerPage';
import JsonFormatterPage from './pages/JsonFormatterPage';
import JsonComparePage from './pages/JsonComparePage';
import FaqPage from './pages/FaqPage';
import MarkdownPreviewPage from './pages/MarkdownPreviewPage';
import UuidGeneratorPage from './pages/UuidGeneratorPage';
import PasswordGeneratorPage from './pages/PasswordGeneratorPage';
import CronExpressionPage from './pages/CronExpressionPage';
import './styles/App.css';

const AppContent = () => {
  const { darkMode } = useDarkMode();
  
  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/text-compare" element={<TextComparePage />} />
          <Route path="/text-checker" element={<TextCheckerPage />} />
          <Route path="/json-validator" element={<JsonFormatterPage />} />
          <Route path="/json-compare" element={<JsonComparePage />} />
          <Route path="/faqs" element={<FaqPage />} />
          <Route path="/markdown-preview" element={<MarkdownPreviewPage />} />
          <Route path="/uuid-generator" element={<UuidGeneratorPage />} />
          <Route path="/password-generator" element={<PasswordGeneratorPage />} />
          <Route path="/cron-expression" element={<CronExpressionPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

function App() {
  return (
    <DarkModeProvider>
      <AppContent />
    </DarkModeProvider>
  );
}

export default App; 